import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _this = this;

import { debounce } from 'lodash';
import React, { useState, useEffect, useCallback } from 'react';
import { Col, Form, Row, Container, ButtonGroup, Button } from "react-bootstrap";
import { useHistory } from 'react-router-dom';
import { StateBootstrapButton as StateButton } from '../forms/elements';
import { connect, ReactReduxContext } from 'react-redux';
import { mobilepayDuck } from "../../ducks/mobilepay";
import currency from "currency.js";
import { MobilePayTip } from './MobilePayTip';
import { MobiliePayPayments } from "./MobilePayPayments";
import PegModule from "../loyalty/PegModule";
import { useFlags } from 'launchdarkly-react-client-sdk';
var mobilepayOperations = mobilepayDuck.operations;
import WarningIcon from "../../images/svg/Warning-Icon.svg";
import { AuthenticationState } from "react-aad-msal";
import { getSessionStorageKey } from '../../util/sessionStorage';

var MobilePayCheckout = function MobilePayCheckout(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      externalPayment = _useState2[0],
      setExternalPayment = _useState2[1];

  var _useState3 = useState("creditcard"),
      _useState4 = _slicedToArray(_useState3, 2),
      paymentType = _useState4[0],
      setPaymentType = _useState4[1]; // const [tipAmount, setTipAmount] = useState(0.00)


  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      tipPercent = _useState6[0],
      setTipPercent = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      giftCard = _useState8[0],
      setGiftCard = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      giftCardPin = _useState10[0],
      setGiftCardPin = _useState10[1];

  var _useState11 = useState(1),
      _useState12 = _slicedToArray(_useState11, 2),
      activeCategoryIndex = _useState12[0],
      setActiveCategoryIndex = _useState12[1];

  var sections = ["Receipt Details", "Payment Info", "Gratuity"];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isSubmitting = _useState14[0],
      setIsSubmitting = _useState14[1];

  var receipt = props.receipt,
      check = props.check,
      setPayOrderPayload = props.setPayOrderPayload,
      total = props.total,
      setGratuity = props.setGratuity,
      payload = props.payload,
      payForOrder = props.payForOrder,
      gratuity = props.gratuity,
      showMobilePayWPError = props.showMobilePayWPError,
      mobilepaystore = props.mobilepaystore,
      isLoading = props.isLoading,
      code1 = props.code1,
      orderId = props.orderId,
      authenticationState = props.authenticationState,
      fields = props.fields;
  var flags = useFlags();
  var releaseMobilePaySignIn = flags['releaseMobilePaySignIn'] ? flags['releaseMobilePaySignIn'] : false;
  var isAuthenticated = authenticationState === "Authenticated"; // console.log("MobilePayCheckout Props", props);

  var signInButtonLink = fields === null || fields === void 0 ? void 0 : fields.SignInLink.value.href;
  var signInButtonLabel = fields === null || fields === void 0 ? void 0 : fields.SignInLink.value.text;

  var submitPayment = function submitPayment() {
    setIsSubmitting(true);
  };

  var submitGiftCardPayment = function submitGiftCardPayment() {
    var payload = {
      Store: parseInt(code1),
      OrderCode: check.OrderCode,
      OrderTotal: check.TotalToPay,
      Gratuity: gratuity,
      Payments: [{
        TokenType: "GIFT",
        PaymentAmount: check.TotalToPay,
        AuthorizationToken: giftCard,
        Pin: giftCardPin,
        CardBin: giftCard.slice(0, 6),
        CardType: "GIFT",
        CardSuffix: giftCard.slice(-4)
      }]
    };
    payForOrder(payload);
  }; // Need to move this to avoid rerender
  // const canUseGooglePay = googlePayEnabled(props); //googlePayEnabled(props);


  var _useState15 = useState(true),
      _useState16 = _slicedToArray(_useState15, 2),
      canUseApplePay = _useState16[0],
      setCanUseApplePay = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      googleLoaded = _useState18[0],
      setGoogleLoaded = _useState18[1];

  var hideApplePaymentOption = (mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.IsApplePayEnabled) != "1"; // console.log('MobilePayCheckout',mobilepaystore)

  var history = useHistory();

  if (receipt) {
    history.push("/mobilepay/success");
  }

  useEffect(function () {
    var mobilePayStorage = getSessionStorageKey('mobilepay');

    if (!(mobilePayStorage === null || mobilePayStorage === void 0 ? void 0 : mobilePayStorage.check) && window.location.href.indexOf('localhost:9009') === -1) {
      window.location.href = "/mobilepay";
      return null;
    }
  }, []);
  var mobilePayBarText = null;

  if (authenticationState === AuthenticationState.Authenticated) {
    var _fields$signedInInfor;

    mobilePayBarText = (fields === null || fields === void 0 ? void 0 : (_fields$signedInInfor = fields.signedInInformationBar) === null || _fields$signedInInfor === void 0 ? void 0 : _fields$signedInInfor.value) || null;
  } else {
    var _fields$notSignedInIn;

    mobilePayBarText = (fields === null || fields === void 0 ? void 0 : (_fields$notSignedInIn = fields.notSignedInInformationBar) === null || _fields$notSignedInIn === void 0 ? void 0 : _fields$notSignedInIn.value) || null;
  }

  return /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("h2", {
      className: "mobilePay_title"
    }, "Mobile Pay"), mobilePayBarText ? /*#__PURE__*/React.createElement("div", {
      className: "mobilePay_bar cb-bg-linen",
      dangerouslySetInnerHTML: {
        __html: mobilePayBarText
      }
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "mobilepay-checkout-container"
    }, check && /*#__PURE__*/React.createElement(ReceiptDetails, _extends({
      index: 0,
      activeCategoryIndex: activeCategoryIndex,
      defaultActive: false,
      check: check,
      mobilepaystore: mobilepaystore,
      tipAmount: gratuity,
      tipPercent: tipPercent,
      setTipPercent: setTipPercent,
      setGratuity: setGratuity,
      total: total
    }, props)), check && orderId && /*#__PURE__*/React.createElement(Form, {
      id: "fCheckout",
      name: "fCheckout"
    }, /*#__PURE__*/React.createElement(MobiliePayPayments, _extends({
      canUseGooglePay: true,
      canUseApplePay: canUseApplePay,
      setCanUseApplePay: setCanUseApplePay,
      hideApplePaymentOption: hideApplePaymentOption,
      googleLoaded: googleLoaded,
      setGoogleLoaded: setGoogleLoaded,
      hideGooglePay: (mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.IsGooglePayEnabled) != "1",
      hideGiftCard: (mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.IsGiftCardEnabled) != "1",
      orderId: orderId,
      total: total,
      code1: code1,
      isLoading: isLoading,
      paymentType: paymentType,
      setPaymentType2: setPaymentType,
      setGiftCard: setGiftCard,
      setGiftCardPin: setGiftCardPin,
      giftCard: giftCard,
      giftCardPin: giftCardPin
    }, props, {
      tipAmount: gratuity
    })), releaseMobilePaySignIn ? /*#__PURE__*/React.createElement("div", {
      className: "mobileSignInButtonsDiv"
    }, /*#__PURE__*/React.createElement(StateButton, {
      type: "submit",
      id: "checkoutnform-wp",
      className: "cb-button-primary ".concat(isSubmitting ? 'is-fetching' : ''),
      onClick: submitPayment
    }, isAuthenticated ? "Submit Payment" : "Pay as Guest"), !isAuthenticated && /*#__PURE__*/React.createElement(StateButton, {
      id: "signIn",
      href: signInButtonLink,
      loading: isLoading,
      className: "cb-button-secondary"
    }, signInButtonLabel)) : /*#__PURE__*/React.createElement(Row, null, paymentType == "creditcard" && /*#__PURE__*/React.createElement(StateButton, {
      type: "submit",
      id: "checkoutnform-wp",
      className: "mobilepay-payment-button ".concat(isSubmitting ? 'is-fetching' : ''),
      onClick: submitPayment
    }, "Submit Payment"), paymentType == "giftcard" && /*#__PURE__*/React.createElement(StateButton, {
      id: "checkout-gift",
      loading: isLoading,
      className: "mobilepay-payment-button",
      onClick: function onClick() {
        submitGiftCardPayment();
      }
    }, "Submit Payment")))));
  }.bind(_this));
};

var ReceiptDetails = function ReceiptDetails(props) {
  var _check$OrderLines, _props$fields, _props$fields2;

  var index = props.index,
      activeCategoryIndex = props.activeCategoryIndex,
      _props$defaultActive = props.defaultActive,
      defaultActive = _props$defaultActive === void 0 ? false : _props$defaultActive,
      check = props.check,
      mobilepaystore = props.mobilepaystore,
      tipAmount = props.tipAmount,
      tipPercent = props.tipPercent,
      setTipPercent = props.setTipPercent,
      total = props.total;
  var tipOptions = [15, 20, 25]; // console.log(check.TotalToPay, tipAmount, total)

  var LineItem = function LineItem(props) {
    var title = props.title,
        value = props.value;
    return /*#__PURE__*/React.createElement("li", {
      className: "mobilepay-receipt-item-subtotal"
    }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement("span", null, value));
  };

  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(SectionBanner, {
    index: index,
    activeCategoryIndex: activeCategoryIndex,
    defaultActive: defaultActive,
    value: "Receipt Details"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Col, {
    className: "receipt_container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "location-container"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "location-info"
  }, mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.AlternateName), /*#__PURE__*/React.createElement("p", {
    className: "location-subinfo"
  }, mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.Address1, " ", mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.City, (mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.State) !== undefined ? "," : "", " ", /*#__PURE__*/React.createElement("br", null), " ", mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.State, " ", mobilepaystore === null || mobilepaystore === void 0 ? void 0 : mobilepaystore.Zip)), /*#__PURE__*/React.createElement("h2", {
    className: "meal-heading"
  }, "Your Meal"), /*#__PURE__*/React.createElement("ul", {
    className: "mobilepay-receipt-list"
  }, check === null || check === void 0 ? void 0 : (_check$OrderLines = check.OrderLines) === null || _check$OrderLines === void 0 ? void 0 : _check$OrderLines.map(function (item, index) {
    return /*#__PURE__*/React.createElement(CostLine, {
      cost: item.Amount,
      isNegative: false,
      title: " (".concat(item.Quantity, ")  ").concat(item.Description)
    });
  }), /*#__PURE__*/React.createElement(LineItem, {
    title: "Subtotal",
    value: "".concat(currency(check.NetAmountWithNoTax).format())
  }), /*#__PURE__*/React.createElement(LineItem, {
    title: "Tax",
    value: " ".concat(currency(check.Tax).format())
  }), isNaN(tipAmount) === false && tipAmount > 0.0 && /*#__PURE__*/React.createElement(LineItem, {
    title: "Tip",
    value: "".concat(currency(tipAmount).format())
  }), /*#__PURE__*/React.createElement(LineItem, {
    title: "Total",
    value: "".concat(currency(total).format())
  }), props && props.store && /*#__PURE__*/React.createElement("li", {
    className: "mobilepay-receipt-item-subtotal"
  }, /*#__PURE__*/React.createElement(PegModule, {
    store: props === null || props === void 0 ? void 0 : props.store,
    isMobilePay: true,
    authenticationState: props.authenticationState,
    fields: ((_props$fields = props.fields) === null || _props$fields === void 0 ? void 0 : _props$fields.PegModule) && ((_props$fields2 = props.fields) === null || _props$fields2 === void 0 ? void 0 : _props$fields2.PegModule.length) >= 1 ? props.fields.PegModule[0].fields : {}
  }))))), /*#__PURE__*/React.createElement(MobilePayTip, _extends({}, props, {
    percentageList: tipOptions,
    tipPercent: tipPercent,
    setTipPercent: setTipPercent
  })), tipAmount >= check.NetAmountWithNoTax && /*#__PURE__*/React.createElement("div", {
    className: "mobilepay-tip-warning"
  }, /*#__PURE__*/React.createElement("img", {
    className: "mobilepay-tip-warning-icon",
    src: WarningIcon
  }), /*#__PURE__*/React.createElement("span", {
    className: "mobilepay-tip-warning-text"
  }, "That's very generous! Please confirm your tip amount to make sure you entered that correctly.")));
};

var SectionBanner = function SectionBanner(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      index = _ref.index,
      activeCategoryIndex = _ref.activeCategoryIndex,
      _ref$defaultActive = _ref.defaultActive,
      defaultActive = _ref$defaultActive === void 0 ? false : _ref$defaultActive,
      children = _ref.children,
      _ref$showNumber = _ref.showNumber,
      showNumber = _ref$showNumber === void 0 ? true : _ref$showNumber;
  return /*#__PURE__*/React.createElement("h2", {
    className: "mobilepay-section-banner ".concat(activeCategoryIndex === index || defaultActive ? "is-active" : "")
  }, (showNumber ? index + 1 + ". " : "") + value, children);
};

var CostLine = function CostLine(_ref2) {
  var _ref2$cost = _ref2.cost,
      cost = _ref2$cost === void 0 ? 0 : _ref2$cost,
      title = _ref2.title,
      isNegative = _ref2.isNegative;
  return Boolean(cost) && /*#__PURE__*/React.createElement("li", {
    className: "mobilepay-receipt-item"
  }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement("span", null, typeof cost === "number" ? "".concat(isNegative ? "-$" : "$").concat(cost.toFixed(2)) : cost));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$mobilepay, _state$mobilepay$chec, _state$mobilepay2;

  var total2Pay = currency(((_state$mobilepay = state.mobilepay) === null || _state$mobilepay === void 0 ? void 0 : (_state$mobilepay$chec = _state$mobilepay.check) === null || _state$mobilepay$chec === void 0 ? void 0 : _state$mobilepay$chec.TotalToPay) || 0.00);
  var gratuity = currency(((_state$mobilepay2 = state.mobilepay) === null || _state$mobilepay2 === void 0 ? void 0 : _state$mobilepay2.Gratuity) || 0.00);
  return {
    isLoading: state.mobilepay.isLoading,
    check: state.mobilepay.check,
    receipt: state.mobilepay.receipt,
    code1: state.mobilepay.code1,
    code2: state.mobilepay.code2,
    payload: state.mobilepay.payload,
    gratuity: state.mobilepay.Gratuity,
    total: total2Pay.add(gratuity),
    orderId: state.mobilepay.OrderId,
    mobilepaystore: state.mobilepay.location
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    reset: function reset() {
      return dispatch(mobilepayOperations.reset());
    },
    payForOrder: function payForOrder(payload) {
      return dispatch(mobilepayOperations.payForOrder(payload));
    },
    setPayOrderPayload: function setPayOrderPayload(payload) {
      return dispatch(mobilepayOperations.setPayOrderPayload(payload));
    },
    setGratuity: function setGratuity(gratuity) {
      return dispatch(mobilepayOperations.setGratuity(gratuity));
    },
    showMobilePayWPError: function showMobilePayWPError(errorNumber) {
      return dispatch(mobilepayOperations.showMobilePayWPError(errorNumber));
    },
    setIsLoading: function setIsLoading(isLoading) {
      return dispatch(mobilepayOperations.setIsLoading(isLoading));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MobilePayCheckout);